/* eslint-disable no-undef */

export const traeUsuario = async (userID) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/usuarios/${userID}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        }
    });
    return response;
};

export const enviaNuevoUsuario = async (data) => {
    // HACE FALTA DISTINGUIR ENTRE ENVIAR UN EXPEDIENTE
    // NUEVO O EDICIONES DE UNO EXISTENTE
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/usuarios/`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'include', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response;
};

export const actualizaUsuario = async (data) => {
    const id = data._id;
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/usuarios/${id}`, {
        method: 'PUT', // *GET, POST, PUT, DELETE, etc.
        //mode: 'cors', // no-cors, *cors, same-origin
        //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'include', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        },
        //redirect: 'follow', // manual, *follow, error
        //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response;
};

export const borraUsuario = async (userID) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/usuarios/${userID}`, {
        method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
        credentials: 'include', // include, *same-origin, omit
        headers: {
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        }
    });
    return response;
};

export const buscaUsuarios = async ({termino}) => {
    /* fetch('https://example.com?' + new URLSearchParams({
        foo: 'value',
        bar: 2,
    })) */
    const url = termino ? `${process.env.REACT_APP_SERVER_URL}/usuarios?`  + new URLSearchParams({
        termino
    }) : `${process.env.REACT_APP_SERVER_URL}/usuarios`;
    const response = await fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Access-Control-Allow-Credentials': true
        }
    });
    return response;
};
